export default function getNestedValue(path, root, defaultValue) {
  return traverseGetNestedValue(path, root, defaultValue, 0)
}

function traverseGetNestedValue(path, root, defaultValue, index) {
  if (root === undefined) {
    return resolveDefaultValue(defaultValue)
  }

  if (index === path.length - 1) {
    const value = root[path[path.length - 1]]
    return value === undefined ? resolveDefaultValue(defaultValue) : value
  } else {
    const nested = root[path[index]]
    if (nested === undefined) {
      return resolveDefaultValue(defaultValue)
    }

    return traverseGetNestedValue(path, nested, defaultValue, index + 1)
  }
}

function resolveDefaultValue(defaultValue) {
  if (typeof defaultValue === "function") {
    return defaultValue()
  }

  return defaultValue
}



// WEBPACK FOOTER //
// ../ui-kit/src/lib/nested-values/getNestedValue.js